import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

type LabTabsProps = {
  valueTab: string | undefined;
  setValueTab?: React.Dispatch<React.SetStateAction<string>>;
  tabTitle?: React.ReactNode;
  tabPanel?: React.ReactNode;
  handleChange: any;
  sx?: any;
};
export default function CustomMuiTab(props: LabTabsProps) {
  const { valueTab, tabPanel, tabTitle, handleChange, sx } = props;

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={valueTab ? valueTab : ""}>
        <Box>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            {tabTitle}
          </TabList>
        </Box>
        {tabPanel}
      </TabContext>
    </Box>
  );
}
